module.exports = __webpack_public_path__ + "img/demo-counter.b38145e4.png";